module.exports = __webpack_public_path__ + "img/img6_3.6532cc8b.jpeg";